export default class GrowingTextarea {
  static grow(textarea) {
    const newHeight = Math.min(textarea.scrollHeight, 600)
    if (newHeight > textarea.clientHeight) {
      textarea.style.height = newHeight + 'px'
    }
  }
}
